const PREFIX = "bill-details-banner";

export const BILL_DETAILS_BANNER_TEST_IDS = {
    CONTAINER: `${PREFIX}-container`,
    TITLE: `${PREFIX}-title`,
    SUBTITLE: `${PREFIX}-subtitle`,
    CLICKABLE_TEXT: `${PREFIX}-clickable-text`,
    HALF_CARD: {
        CONTAINER: `${PREFIX}-half-card-container`,
        TITLE: `${PREFIX}-half-card-title`,
        CONTENT_WRAPPER: `${PREFIX}-half-card-content-wrapper`,
        CONTENT_TEXT: `${PREFIX}-half-card-content-text`,
        CTA_BUTTON: `${PREFIX}-half-card-cta-button`,
    },
};
